import React from 'react'
import Style from './Input.module.css'
const Input = (props,{ref}) => {
    let inputElementType=null
    switch(props.inputtype){
        case 'text':
            inputElementType=<input className={Style.InputStyle} {...props}  />
            break;
        case 'valid':
            inputElementType=<input className={Style.PanelInput}  {...props}/>
            break;
        case 'Confirm':
            inputElementType=<input className={`${Style.confirmNumber} ${Style.InputStyle}`}  {...props}/>
            break;
        case 'textArea' :   
            inputElementType=<textarea className={Style.textareaStyle}  {...props}/>
            break;
        default:
            inputElementType=<input {...props} className={Style.InputStyle}  />
            break;
    }
    return (
        <div className={Style.InputHolder}>
            {inputElementType}
        </div>
    )
}

export default Input
